export const GET_PRESCRIBER_LIST = "GET_PRESCRIBER_LIST"
export const CLEAR_PRESCRIBER_LIST ="CLEAR_PRESCRIBER_LIST"